import { render, staticRenderFns } from "./UserMyvip.vue?vue&type=template&id=203012c4&"
import script from "./UserMyvip.vue?vue&type=script&lang=js&"
export * from "./UserMyvip.vue?vue&type=script&lang=js&"
import style0 from "./UserMyvip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports